// Smart Infovision — real site media
// Sourced from smartinfovision.com and smartinfovision.shop
// Stock-photo URLs (Unsplash / Pexels) are deprecated and must NOT be reused.

// --- Hero / banner imagery -------------------------------------------------
export const HERO_BANNERS = [
  "https://smartinfovision.shop/cdn/shop/files/Home_Banner_10_1.png?v=1750314000&width=3840",
  "https://smartinfovision.shop/cdn/shop/files/Home_Banner_11.png?v=1750335609&width=3840",
  "https://smartinfovision.shop/cdn/shop/files/SIV_Showroom_1.png?v=1744102268&width=3840",
  "https://smartinfovision.shop/cdn/shop/files/product_3.png?v=1729937077&width=3840",
  "https://smartinfovision.shop/cdn/shop/files/1920X1080_banner_1.png?v=1749622938&width=3840",
];

// Single dominant hero image used on /, /city pages, etc.
export const HERO_PRIMARY =
  "https://smartinfovision.shop/cdn/shop/files/SIV_Showroom_1.png?v=1744102268&width=2400";

export const SHOWROOM_IMAGE =
  "https://smartinfovision.shop/cdn/shop/files/SIV_Showroom_1.png?v=1744102268&width=2400";

// --- Product imagery -------------------------------------------------------
// All Benchmark Technomate / Maxhub product shots from the official .shop CDN.
export const PRODUCT_IMG = {
  digitalBoard:
    "https://smartinfovision.shop/cdn/shop/files/Sigma_AI-A7_ZX_1_2.png?v=1775817314&width=1200",
  smartClassKit:
    "https://smartinfovision.shop/cdn/shop/files/Online_class_studio_setup_1.png?v=1747314565&width=1200",
  coachingSetup:
    "https://smartinfovision.shop/cdn/shop/files/hybrid_class_studio.png?v=1747229606&width=1200",
  panIndia:
    "https://smartinfovision.shop/cdn/shop/files/Virtual_setup_1.png?v=1746714477&width=1200",
  panel65to86:
    "https://smartinfovision.shop/cdn/shop/files/BENCHMARK-GALAXY-11.1.png?v=1717660000&width=1426",
  ptzCamera:
    "https://smartinfovision.shop/cdn/shop/files/BENCHMARK_CAMERA_-_01.png?v=1717846146&width=1200",
  ops:
    "https://smartinfovision.shop/cdn/shop/files/OPENER_OF_THE_DAY_JUNE_11_5.png?v=1718178887&width=1200",
  podiumLight:
    "https://smartinfovision.shop/cdn/shop/files/Studio_Light_Catalog_1__page-0001.jpg?v=1737803399&width=1200",
  podcastMic:
    "https://smartinfovision.shop/cdn/shop/files/BENCHMARK-05.png?v=1718111868&width=1200",
  vloggingMic:
    "https://smartinfovision.shop/cdn/shop/files/OPENER_OF_THE_DAY_JUNE_11_3.png?v=1718178406&width=1200",
};

// --- Curated panels for product grids -------------------------------------
export const FEATURED_PANELS = [
  {
    title: "Benchmark Technomate Millenium",
    desc: "Flagship 4K IFP, Android 14, AI tools, zero-air-gap glass.",
    img: "https://smartinfovision.shop/cdn/shop/files/WhatsAppImage2026-04-10at16.29.09.jpg?v=1775822605&width=1200",
    price: "₹2,20,000",
  },
  {
    title: "Benchmark Sigma AI ZX",
    desc: "AI-powered Digital Board for teachers — 65/75/86\".",
    img: "https://smartinfovision.shop/cdn/shop/files/Sigma_AI-A7_ZX_1_2.png?v=1775817314&width=1200",
    price: "₹1,95,000",
  },
  {
    title: "Benchmark MaxPro Ultra AI",
    desc: "Zero writing delay, 8GB RAM, anti-glare 4K touch panel.",
    img: "https://smartinfovision.shop/cdn/shop/files/1_190be72f-2bb8-4312-80c4-bd6585916d80.png?v=1756975532&width=1200",
    price: "₹1,55,000",
  },
  {
    title: "Benchmark Galaxy 14 AI",
    desc: "Best-seller IFP for online teaching & coaching institutes.",
    img: "https://smartinfovision.shop/cdn/shop/files/BENCHMARK-GALAXY-11.1.png?v=1717660000&width=1426",
    price: "₹1,45,000",
  },
  {
    title: "Benchmark Classic IFP",
    desc: "Android 14, premium build, best price-to-feature ratio.",
    img: "https://smartinfovision.shop/cdn/shop/files/1_5c0636c1-086b-446c-9c0b-9748cbed24e7.png?v=1757135519&width=1200",
    price: "₹1,25,000",
  },
  {
    title: "MAXHUB U3",
    desc: "Premium Maxhub IFP with optional OPS module.",
    img: "https://smartinfovision.shop/cdn/shop/files/ShopMaxhub1.png?v=1729316004&width=1200",
    price: "₹2,10,000",
  },
];

// --- Studio setups ---------------------------------------------------------
export const STUDIO_SETUPS = [
  {
    title: "Hybrid Class Studio",
    desc: "Bridge online + offline teaching — IFP + camera + mic + lights.",
    img: "https://smartinfovision.shop/cdn/shop/files/hybrid_class_studio.png?v=1747229606&width=1200",
  },
  {
    title: "Online Teaching Studio",
    desc: "Plug-and-play setup for full-time YouTube / coaching teachers.",
    img: "https://smartinfovision.shop/cdn/shop/files/Online_class_studio_setup_1.png?v=1747314565&width=1200",
  },
  {
    title: "Virtual Studio",
    desc: "Pro virtual background + camera tracking setup.",
    img: "https://smartinfovision.shop/cdn/shop/files/Virtual_setup_1.png?v=1746714477&width=1200",
  },
  {
    title: "Green Chroma Studio",
    desc: "Professional green-screen studio for explainer videos.",
    img: "https://smartinfovision.shop/cdn/shop/files/Green_Chroma_setup_2.png?v=1746714356&width=1200",
  },
  {
    title: "Pentab Studio Setup",
    desc: "Affordable pen-tab studio for digital teaching.",
    img: "https://smartinfovision.shop/cdn/shop/files/Pentab_setup_1.png?v=1746714381&width=1200",
  },
  {
    title: "Conference Studio",
    desc: "Premium boardroom + hybrid conferencing studio.",
    img: "https://smartinfovision.shop/cdn/shop/files/Conference_setup_1.png?v=1746714419&width=1200",
  },
];

// --- Brand logo strip ------------------------------------------------------
export const BRAND_LOGOS = [
  { name: "Benchmark Technomate", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_9.png?v=1737799132&width=250" },
  { name: "Maxhub", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_3-1_1x_1.png?v=1737799149&width=250" },
  { name: "BenQ", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_1-1_1x_1.png?v=1737799150&width=250" },
  { name: "LG", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_2.png?v=1737799154&width=250" },
  { name: "Samsung", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_5-1_1x_1.png?v=1737799150&width=250" },
  { name: "Rode", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_4-1_1x_1.png?v=1737799149&width=250" },
  { name: "Shure", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_6-1_1x_1.png?v=1737799149&width=250" },
  { name: "ViewSonic", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_7-1_1x_1.png?v=1737799149&width=250" },
  { name: "Newline", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_11_04ef779c-1e40-484e-bcbb-95a1720c9308.png?v=1744465635&width=250" },
  { name: "Teachmint", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_12.png?v=1744537596&width=250" },
  { name: "Senses", img: "https://smartinfovision.shop/cdn/shop/files/Artboard_13.png?v=1744537596&width=250" },
];

// --- Blog seed covers (used by seed_data) ---------------------------------
export const BLOG_COVER_DEFAULT = HERO_PRIMARY;
